<template>
  <div>
    <div class="mass-assignments-modal-search">
      <template>
        <div class="d-flex">
          <div class="custom-control custom-checkbox menu-label mass-assignments-modal-search--checkbox"
               :class="{'partial-checked': partialChecked}" @click="toggleCheckedSearch">
            <input type="checkbox" class="custom-control-input" v-model="allChecked" value="1" checked>
            <span class="custom-control-label" style="cursor: pointer">{{ '' }}</span>
          </div>
          <div class="d-flex flex-column mass-assignments-modal-search--search">
            <span class="adp-th">{{ $t('catalog.assign_search_group') }}</span>
            <input type="text" class="adp-input adp-input__catalog adp-input-search" v-model="search">
          </div>
        </div>
      </template>
    </div>

    <div class="alert alert-danger notifications-error" role="alert" v-if="errorText">
      {{ errorText }}
    </div>

    <div class="mass-assignments-modal-block">
      <div class="adp-big-modal-row">
        <structure-tree v-if="checkedItems[company.id]"
                        v-for="(company, key) in resultCompanies"
                        class="menu"
                        :key="company.id"
                        :parent="company"
                        :label="key"
                        :open="false"
                        :search="search"
                        :presetValues="presetValues"
                        :parentChecked="checkedItems[company.id].checked"
                        :parentLevel="0"
                        :checkedItems="checkedItems[company.id]"
                        :parentShowMobile="checkedItems[company.id].showMobile"
                        @toggleMobile="toggleMobile"
                        @updateItemsSearch="updateItemsSearch"
                        @updateItemsChecked="updateItemsChecked">
        </structure-tree>
      </div>
      <div class="mass-assignments-modal-block--assign">
        <button class="btn adp-btn" @click="saveSettings" :class="{'disabled': loading}" :disabled="loading">{{ $t('voc.save') }}</button>
      </div>

      <div class="form-group row mb-0 mass-assignments-modal-block--assign-main" style="margin-top: 25px">
        <div class="col-md-4 offset-md-8">
          <button type="submit" class="btn btn-primary adp-btn adp-btn__large" :class="{'disabled': loading}" :disabled="loading" @click="saveSettings">
            {{ $t('voc.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StructureTree from "./StructureTree";

export default {
    name: "Notifications",
    components: {StructureTree},
    props: {
      inputData: {
        type: String,
        required: true
      }
    },

    data: function () {
      return {
        search: '',
        loading: false,
        companies: {},
        presetValues: {},
        resultCompanies: {},
        checkedItems: {},

        errorText: '',

        noUsersError: false,

        partialChecked: false,
        allChecked: false,
      }
    },
    watch: {
      search: function () {
        this.noUsersError = false;
      }
    },
    created() {
        this.companies = Object.assign({}, JSON.parse(this.inputData).companies);
        this.presetValues = Object.assign({}, JSON.parse(this.inputData).presetValues);
        this.resultCompanies = Object.assign({}, JSON.parse(this.inputData).companies);

        for (let [key, value] of Object.entries(this.companies)) {
          let checked = true;
          let changed = true;
          let id = false;

          if(this.presetValues[value.type] && this.presetValues[value.type][value.id]) {
            checked = !! this.presetValues[value.type][value.id].status;
            changed = false;
            id = this.presetValues[value.type][value.id].id;
          }

          this.checkedItems[value.id] = {
            partialChecked: false, items: {}, id: value.id, presetId: id,
            checked: checked, changed: changed,
            inSearch: false, itemsSearch: false,
            showMobile: true, itemsOpenMobile: false,
            type: value.type, name: value.name,
          }
        }
    },
    methods: {
      toggleCheckedSearch() {
        this.allChecked = !this.allChecked;

        _.each(this.checkedItems, (item) => {
          item.checked = this.allChecked;
        });
      },

      toggleMobile(id, open) {
        this.partialChecked =
          _.each(this.checkedItems, (item) => {
            if(id !== item.id) {
              item.showMobile = open;
            }
          });
        this.checkedItems = Object.assign({}, this.checkedItems);
      },

      updateItemsChecked() {
        const length = Object.keys(this.checkedItems).length;

        const checkedItems = Object.values(this.checkedItems).filter(function (item) {
          return item.checked;
        });

        const partialCheckedItems = Object.values(this.checkedItems).filter(function (item) {
          return item.partialChecked;
        });

        this.partialChecked = (checkedItems.length && checkedItems.length !== length) || partialCheckedItems.length;

        if (checkedItems.length && checkedItems.length === length) this.allChecked = true;
        if (!checkedItems.length && !partialCheckedItems.length) this.allChecked = false;
      },

      updateItemsSearch() {
      },

      assign(checked) {
        axios.put(window.IDP.role + '/structure/assignments', {
          users: checked,
          activities: this.activities
        }).then(response => {
          this.$bvModal.hide('mass-assignments-modal');
        });
      },

      getChangedItems(items) {
        let checked = {}

        Object.keys(items).forEach(key => {
          if (items[key].changed || !items[key].presetId) {
            checked[key] = {'type': items[key].type, 'id': items[key].presetId, 'checked': items[key].checked, 'changed': items[key].changed};

            if (items[key].items && Object.keys(items[key].items).length && (items[key].changed || items[key].partialChecked)) {
              let children = this.getChangedItems(items[key].items);
              if(Object.keys(children).length) {
                checked[key].items = children;
              }
            }
          }
        });

        return checked;
      },

      saveSettings() {
        if(this.loading) {
          return;
        }

        this.loading = true;
        this.errorText = '';

        let items = this.getChangedItems(this.checkedItems);

        axios.post('/admin/company/notificationSettings', items).then(response => {
          this.loading = false;
          if(response.data.success) {
            window.location.reload();
          } else {
            if(response.data.error) {
              this.errorText = response.data.error;
            }
          }

        });
      }
    }
  }
</script>

<style scoped>
  .menu {
    text-decoration: none;
    list-style: none;
    margin-left: 5px;
  }

  .adp-filter-input--no-result {
    padding-left: 24px;
    margin-top: 20px;
    font-size: 16px;
  }

  .notifications-error {
    margin-left: 25px;
    margin-right: 25px;
    margin-top: 25px;
  }
</style>
